import $ from 'jquery';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

function initProductFilters(e) {
	const widgets = $('.widget_berocket_aapf');
	if(widgets.length > 0) {
		widgets.each(function() {
			var widget = $(this);
			var filters = widget.find('.berocket_aapf_widget > li').not('.slider, .berocket_widget_show_values');
			if(filters.length === 1) {
				widget.hide();
			} else {
				widget.show();
			}

			widget.find('.berocket_aapf_widget-title').click(function() {
				if(els.viewport.width() >= breakpoints.sm) {
					$(this).closest('.widget_berocket_aapf').toggleClass('active');
					$(this).next('.berocket_aapf_widget').slideToggle(250);
				}
			});
		});
	} else if($("body").hasClass("tax-product_cat")) {
		// Hide mobile controls if on a product category page without any filters available
		$(".mobile-controls").css("display", "none");
	}
}

document.addEventListener('DOMContentLoaded', initProductFilters);
